import { getLocale, subscribe } from "./i18n.js";

window.__JANUS_VERSION__ = "1.8.0";

const skipLabel = (locale) => locale === "en" ? "Skip to content" : "Aller au contenu";
const syncGlobalSkipLink = (locale) => {
  const link = document.querySelector("[data-global-skip-link]");
  if (link) link.textContent = skipLabel(locale);
};

const legacyDocsRoute = window.location.pathname === "/docs" || window.location.pathname.startsWith("/docs/");

if (window.location.pathname.startsWith("/app")) {
  document.body.innerHTML =
    `<a class="app-skip-link" data-global-skip-link href="#janus-content">${skipLabel(getLocale())}</a><div id="janus-app"></div>`;
  await import("./app/main.jsx");
} else if (legacyDocsRoute) {
  const suffix = window.location.pathname.slice("/docs".length);
  window.location.replace(`/app/docs${suffix}${window.location.search}${window.location.hash}`);
} else {
  await import("./main.js");
}

subscribe(syncGlobalSkipLink);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js?v=25").catch(() => {});
  });
}
